function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M34.976 1.024c1.562 1.563 1.309 4.35-.566 6.225L23.659 18l10.75 10.751c1.876 1.875 2.13 4.662.567 6.225-1.563 1.562-4.35 1.309-6.225-.566L18 23.659 7.249 34.409c-1.875 1.876-4.662 2.13-6.225.567-1.562-1.563-1.309-4.35.566-6.225L12.341 18 1.591 7.249C-.286 5.374-.54 2.587 1.023 1.024 2.587-.538 5.374-.285 7.25 1.59L18 12.341l10.751-10.75c1.875-1.876 4.662-2.13 6.225-.567z",
  fill: "#2071BD",
  fillRule: "evenodd"
})));